import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getMissingData from "../../common/getMissingData";
// import api_comm from "../../common/lib";

export const getMissingMemberData = createAsyncThunk(
	"Missing/Data",
	async (args, { getState }) => {
		const state = getState();

		try {
			// Get items.
			let MissingData = await getMissingData(
				state.Login.Auth.storemember_guid,
				state.Login.Auth.session_token
			);

			return MissingData.data.components[0];
		} catch (e) {
			console.log("Error:::", e);
			throw new Error(e?.message);
		}
	}
);

const initialState = {
	MissingData: [],
	loading: true,
};

export const MissingDataSlice = createSlice({
	name: "MissingData",
	initialState,
	reducers: {
		setMissingData: (state, action) => {
			state.Pages = action.payload;
		},
	},
	extraReducers: {
		[getMissingMemberData.pending]: (state, action) => {
			state.loading = true;
		},
		[getMissingMemberData.fulfilled]: (state, action) => {
			state.MissingData = action.payload;
			state.loading = false;
		},
		[getMissingMemberData.rejected]: (state, action) => {
			state.MissingData = [];

			state.loading = false;
		},
	},
});

export const { setMissingData } = MissingDataSlice.actions;

export default MissingDataSlice.reducer;
